import React, { createContext, useContext, useState, ReactNode } from 'react';

// Create context for amount visibility
type AmountVisibilityContextType = {
  showAmounts: boolean;
  toggleAmountVisibility: () => void;
};

const AmountVisibilityContext = createContext<AmountVisibilityContextType | undefined>(undefined);

// Provider component
export const AmountVisibilityProvider = ({ children }: { children: ReactNode }) => {
  const [showAmounts, setShowAmounts] = useState(false);

  const toggleAmountVisibility = () => {
    setShowAmounts(prev => !prev);
  };

  return (
    <AmountVisibilityContext.Provider value={{ showAmounts, toggleAmountVisibility }}>
      {children}
    </AmountVisibilityContext.Provider>
  );
};

// Hook for using the amount visibility context
export const useAmountVisibility = () => {
  const context = useContext(AmountVisibilityContext);
  if (context === undefined) {
    throw new Error('useAmountVisibility must be used within an AmountVisibilityProvider');
  }
  return context;
};

// Utility function for masking amounts
export const maskAmount = (amount: number, showAmounts: boolean) => {
  return showAmounts ? amount.toLocaleString() : '******';
};